module.exports = __webpack_public_path__ + "static/Download_on_the_App_Store_Badge_FR_RGB_blk_100517-2cfdd0a74cd257a00a1821b968acfa92.svg";